import axios from "@/axios.js"

export default {
  searchVertical({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/verticals/search_vertical/" + item)
        .then((response) => {
          commit('SET_VERTICALS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/verticals/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateVertical({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/verticals/update_vertical", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addVertical({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/verticals/add_verticals", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllVerticals({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/verticals/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_VERTICALS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllTypes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/verticals/types")
        .then((response) => {
          commit('SET_VERTICALS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchVertical(context, verticalId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/verticals/${verticalId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchVerticalList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/verticals/${item}`)
        .then((response) => {
          commit('SELECTED_VERTICAL', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeVertical({
    commit
  }, verticalId) {
    return new Promise((resolve, reject) => {
      // alert(verticalId)
      axios.delete(`/api/verticals/${verticalId}`)
        .then((response) => {
          commit('REMOVE_VERTICAL', verticalId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
